angular.module("digitalLeasing.module").component("bankVerificationNpl", {
  templateUrl: "ng/components/digitalLeasing/resolutionNuovoPrestoLeasing/bankVerification/bankVerificationNpl.view.html",
  bindings: {
    model: "=",
    domande: "=",
    exportValidityGuarantee: "&?",
    validate: "&?",
    check: "&?",
    questionario: "<"
  },
  controllerAs: "bankVerificationNplCtrl",
  controller: function bankVerificationNpl($typeDomainService, $modalService, $simulationService, $rootScope) {
    var self = this;

    self.$onInit = function () {
      console.log("model", self.model);

      self.supportModel = {
        questions: [],
        supportArray: []
      }

      if (self.questionario && self.questionario.length > 0) {
        self.supportModel.questions = self.questionario;
        self.questionario.forEach(function (question) {
          if (question.yesSelected) {
            self.supportModel.supportArray.push(true);
          } else {
            self.supportModel.supportArray.push(false);
          }
        })
        self.handleChange();
      } else {
        self.getQuestionsText();
      }

    };

    self.getQuestionsText = function () {
      $typeDomainService
        .getDomainSet("BANK_RESOLUTION", "CHECKS")
        .then(function (response) {
          self.supportModel.questions = response.domainList;
          self.supportModel.questions.forEach(function (question) {
            var domanda = {
              domanda: question.value,
              cdDomanda: question.name,
              yesSelected: false,
              noSelected: false
            }
            self.questionario.push(domanda);
          })
        })
        .catch(function (error) {
          console.log("deliberaNuovoPrestoLeasing", error);
        })
        .finally(function () {
          console.log("andata deliberaNuovoPrestoLeasing");
        })
    }

    self.handleChange = function (index, value) {

      if (typeof value != undefined && value != null && typeof index != undefined && index != null) {
        if (value == 'true') {
          self.questionario[index].yesSelected = true;
          self.questionario[index].noSelected = false;
        } else {
          self.questionario[index].yesSelected = false;
          self.questionario[index].noSelected = true;
        }
      }


      var result = self.supportModel.supportArray.some(function (item) {
        return item === true;
      })

      var result1 = self.supportModel.supportArray.some(function (item) {
        return item === false || undefined;
      })

      if ((result && result1) || result) {

        if (self.isNotFirstTime) {

          self.model.leasingData.preventivo.deliberaBanca.dataDelibera = null;
          self.model.leasingData.preventivo.deliberaBanca.deliberaPositiva = null;

        }

        self.notPossibleToProceed = true;
        self.exportValidityGuarantee({
          validation: false
        })

        self.check({
          validation: true,
          mode: "BV"
        });

      } else if (result1 && !result) {

        self.notPossibleToProceed = false;

        self.exportValidityGuarantee({
          validation: true
        });

        self.check({
          validation: false,
          mode: "BV"
        });

        self.isNotFirstTime = true;

      }



    }

  },
});
